module.exports = __webpack_public_path__ + "img/feature_buy_en.fb84ebe8.png";